import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { TRACKING_EVENT_NAMES, useTrack, useTrackOnce } from 'hooks/analytics_events'

export const dispatchSegmentEvent = (track, user, eventUuid, isCalendlyMeeting, step, miEventUuid, options = {}) => {
  track({
    name: TRACKING_EVENT_NAMES.AI_NOTETAKER_ENGAGED,
    properties: {
      step,
      attendee_count: null,
      duration_in_minutes: null,
      transcript_generation_in_seconds: null,
      is_calendly_meeting: isCalendlyMeeting ?? true,
      user_uuid: user?.uuid,
      event_uuid: eventUuid,
      mi_event_uuid: miEventUuid,
      ...options
    }
  })
}

export const useSegment = (path, user, eventUuid, isCalendlyMeeting, step, miEventUuid) => {
  const location = useLocation()
  const track = useTrack()

  useEffect(() => {
    if (path === location.pathname) {
      dispatchSegmentEvent(
        track,
        user,
        eventUuid,
        isCalendlyMeeting,
        step,
        miEventUuid,
      )
    }
  }, [eventUuid, isCalendlyMeeting, location.pathname, miEventUuid, path, step, track, user])
}

export function useRecapEmailCTACheck(location, user, eventUuid, isCalendlyMeeting, miEventUuid) {
  const params = new URLSearchParams(location.search)
  const source = params.get('source')
  const askNT = params.get('askNotetaker')
  const askNTQuery = params.get('ask')
  const shareModal = params.get('show_share_modal')
  let action
  if (shareModal === 'True') {
    action = 'share_recording_cta'
  } else if (askNT === 'True') {
    action = askNTQuery ? 'ask_notetaker_ai_question_cta' : 'ask_notetaker_cta'
  } else {
    action = 'watch_recording_cta'
  }
  useTrackOnce(source === 'email', {
    name: TRACKING_EVENT_NAMES.MEETING_RECAP_INTERACTION,
    properties: {
      action,
      location: 'recap_email',
      event_uuid: eventUuid,
      mi_event_uuid: miEventUuid,
      is_calendly_meeting: isCalendlyMeeting,
      is_calendly_user: true,
      is_owner_session: true,
      is_preview: false
    }
  })
}
